import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Cell.st.css.js';
const Cell = ({ span = 12, rows = 1, children, vertical, className, dataHook, }) => (React.createElement("div", { "data-hook": dataHook, style: {
        gridColumn: `span ${span}`,
        gridRow: `span ${rows}`,
    }, className: st(classes.root, { vertical }, className), children: children }));
Cell.displayName = 'Cell';
Cell.propTypes = {
    dataHook: PropTypes.any,
    children: PropTypes.any,
    span: PropTypes.any,
    vertical: PropTypes.any,
    rows: PropTypes.any,
};
export default Cell;
//# sourceMappingURL=Cell.js.map